import moment from "moment";
import {
  AddToCart,
  CreateOrder,
  DeleteItemFromCart,
  GetCart,
  GetOrder,
  GetOrders,
  OrderAddComments,
  OrderHistory,
  OrderRepeat,
  OrderUpdate,
  ProductFilters,
  STORED_ORDER,
  UpdateCart,
  ClearCart,
} from ".";
import {
  LOGOUT,
  LOGOUT_MAINTAIN,
  MAINTAINANCE,
  ReducerFunctions,
} from "../../config/helper";
import {
  Addresses,
  Regions,
  Products,
  GetProfomaDoc,
  UpdateProfomaDoc,
  OpenOrders,
  OpenProducts,
  Payments,
  UpdateInvoice,
  Origins,
  UploadProfomaDoc,
  DownloadPI,
  Cancel,
  ExportFile,
  OrderGetComments,
} from "./Action";
import _ from "lodash";
export const get_addresses_reducer = ReducerFunctions(Addresses, {});
export const export_file_reducer = ReducerFunctions(ExportFile, {});
export const order_repeat_reducer = ReducerFunctions(OrderRepeat, {});
export const order_history_reducer = ReducerFunctions(OrderHistory, {});
export const upload_perfoma_doc_reducer = ReducerFunctions(
  UploadProfomaDoc,
  {}
);
export const order_add_comments_reducer = ReducerFunctions(
  OrderAddComments,
  {}
);
export const order_get_comments_reducer = ReducerFunctions(
  OrderGetComments,
  {}
);
export const get_prod_filters_reducer = ReducerFunctions(ProductFilters, {});
export const update_order_reducer = ReducerFunctions(OrderUpdate, {});
export const get_orders_reducer = (state = {}, action) => {
  let data = Array.isArray(action?.payload)
    ? [...action?.payload]
    : { ...action?.payload };
  switch (action?.type) {
    case GetOrders.REQUEST:
      return {
        ...state,
        data: {},
        loading: true,
      };
    case GetOrders.SUCCESS: {
      let orders = [];
      const checkOrderStatus = (item) => {
        if (item.Augru !== "Z92" && item.SoNumber && item.OrderStatus === "C") {
          return "Completed";
        } else if (item.Augru !== "Z92" && item.SoNumber) {
          return "Confirmed";
        } else if (item.Augru === "Z92") {
          return "Cancelled";
        } else return "To Be Confirmed";
      };

      data?.new_orders?.forEach((ele) => {
        let obj = {
          SKU: ele.Matnr,
          "Unit Price": ele.Netpr,
          Pattern: ele.Maktx,
          Quantity: parseInt(ele.Kwmeng),
          Amount: parseFloat(ele.Netpr) * parseInt(ele.Kwmeng),
          rim: ele["ZStandardrim"],
          li: ele["ZLoadindex"],
          sr: ele["ZSpeedrating"],
          lr: ele["ZLoadrating"],
          Size: ele["ZSize1"],
          appliction: ele["Application"],
          category: ele["ZSeason"],
          total_fill: ele["Fill"],
        };
        let idx = orders.findIndex((itm) => itm.order_number === ele.OrderId);
        if (idx > -1) {
          orders[idx].line_items.push(obj);
          orders[idx].total_quantity = Array.isArray(orders?.[idx]?.line_items)
            ? _.sumBy(orders?.[idx]?.line_items, "Quantity")
            : obj.Quantity
            ? obj.Quantity
            : 0;
          orders[idx].total_price = Array.isArray(orders?.[idx]?.line_items)
            ? _.sumBy(orders?.[idx]?.line_items, "Amount")
            : obj.Amount
            ? obj.Amount
            : 0;
        } else {
          orders.push({
            order_number: ele.OrderId,
            date: moment(ele.QuotationDate, "YYYYMMDD").format("MM/DD/YY"),
            order_type: ele.Vtweg == "42" ? "FD" : "FTL",
            so_number: ele.SoNumber,
            po_number: ele.Bstnk,
            order_status: checkOrderStatus(ele),
            order_sales_nav: ele,
            line_items: [obj],
            delivery_address: `${ele["Street"]}, ${ele["City1"]}, ${ele["Country"]}, ${ele["PostCode1"]}`,
            total_quantity: obj.Quantity ? obj.Quantity : 0,
            total_price: obj.Amount ? obj.Amount : 0,
          });
        }
      });
      if (Array.isArray(data?.orders?.orders))
        data.orders.orders = [...data.orders.orders, ...orders].sort((a, b) => {
          if (a.date === b.date) {
            return b.order_number - a.order_number;
          }
          return new Date(b.date) - new Date(a.date);
        });
      else if (orders?.length > 0)
        data.orders.orders = orders.sort((a, b) => {
          if (a.date === b.date) {
            return b.order_number - a.order_number;
          }
          return new Date(b.date) - new Date(a.date);
        });
      // data.orders.total_records = data?.total_records;
      return {
        data,
        loading: false,
        success: true,
      };
    }
    case GetOrders.FAILED:
      return {
        ...state,
        data,
        loading: false,
        success: false,
      };
    case GetOrders.RESET:
      return {
        loading: false,
      };

    default:
      return state;
  }
};
export const get_order_reducer = (state = { loading: true }, action) => {
  let data = Array.isArray(action?.payload)
    ? [...action?.payload]
    : { ...action?.payload };
  switch (action?.type) {
    case GetOrder.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GetOrder.SUCCESS: {
      return {
        data,
        loading: false,
        success: true,
      };
    }
    case GetOrder.CHANGED: {
      let data1 = JSON.parse(JSON.stringify({ ...state.data?.order }));
      let line_items = data1?.line_items ? data1?.line_items : [];
      console.log(state, ".....state");
      if (action.onlyChange) {
        data1.changed = true;
        return {
          ...state,
          loading: false,
          data: {
            ...state.data,
            order: data1,
            total_price: _.sumBy(data1.line_items, (ele) =>
              parseFloat(ele.Amount)
            ),
            total_quantity: _.sumBy(data1.line_items, (ele) =>
              parseFloat(ele.Quantity)
            ),
          },
        };
      }
      let idx = line_items.findIndex(
        (ele) =>
          ele.product_id === action.line_item.id ||
          ele.id === action.line_item.id
      );
      if (action.fromRow) {
        action.line_item.isChanged = true;
        line_items[idx] = action.line_item;
      } else if (action.isRemove) {
        line_items.splice(idx, 1);
      } else {
        if (idx > -1) {
          line_items[idx].Quantity = parseFloat(action.line_item.quantity);
          line_items[idx].isChanged = true;
          line_items[idx].Amount = Number(
            parseFloat(
              parseFloat(action.line_item.quantity) *
                parseFloat(action.line_item.unit_price)
            ).toFixed(1)
          );
        }
      }

      data1.line_items = line_items;
      data1.total_price = _.sumBy(line_items, (ele) => parseFloat(ele.Amount));
      data1.total_quantity = _.sumBy(line_items, (ele) =>
        parseFloat(ele.Quantity)
      );
      data1.changed = true;
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          order: data1,
          total_price: _.sumBy(data1.line_items, (ele) =>
            parseFloat(ele.Amount)
          ),
          total_quantity: _.sumBy(data1.line_items, (ele) =>
            parseFloat(ele.Quantity)
          ),
        },
      };
    }
    case GetOrder.FAILED:
      return {
        ...state,
        data,
        loading: false,
        success: false,
      };
    case GetOrder.RESET:
      return {
        loading: false,
      };

    default:
      return state;
  }
};
export const get_regions_reducer = ReducerFunctions(Regions, {});
export const get_origins_reducer = ReducerFunctions(Origins, {});
export const open_orders_reducer = ReducerFunctions(OpenOrders, {});
export const open_products_reducer = (state = {}, action) => {
  let data = Array.isArray(action?.payload)
    ? [...action?.payload]
    : typeof action?.payload === "string"
    ? action?.payload
    : { ...action?.payload };
  switch (action?.type) {
    case OpenProducts.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case OpenProducts.SUCCESS: {
      let filters = _.uniqBy(
        data?.open_order_products,
        (ele) => ele.Matnr
      )?.map((ele) => ({ label: ele.Matnr, value: ele.Matnr }));
      return {
        ...state,
        data,
        dataCp: data.open_order_products,
        filters,
        loading: false,
        success: true,
      };
    }
    case OpenProducts.FAILED:
      return {
        ...state,
        data,
        loading: false,
        success: false,
      };
    case OpenProducts.RESET:
      return {
        loading: false,
      };

    case OpenProducts.CHANGED: {
      if (action.payload.isFilter) {
        state.data.open_order_products =
          action.payload.sku?.length > 0
            ? state.dataCp.filter(
                (ele) =>
                  action.payload.sku?.includes(ele.Matnr) ||
                  (action.payload.search &&
                    (ele.Pendingqty?.toLowerCase()?.includes(
                      action.payload.search?.toLowerCase()
                    ) ||
                      ele.Kwmeng?.toLowerCase()?.includes(
                        action.payload.search?.toLowerCase()
                      ) ||
                      ele.Deliveredqty?.toLowerCase()?.includes(
                        action.payload.search?.toLowerCase()
                      ) ||
                      ele.brand
                        ?.toLowerCase()
                        ?.includes(action.payload.search?.toLowerCase()) ||
                      ele.rim
                        ?.toLowerCase()
                        ?.includes(action.payload.search?.toLowerCase()) ||
                      ele.size
                        ?.toLowerCase()
                        ?.includes(action.payload.search?.toLowerCase()) ||
                      ele.refernce_po
                        ?.toLowerCase()
                        ?.includes(action.payload.search?.toLowerCase()) ||
                      ele.li
                        ?.toLowerCase()
                        ?.includes(action.payload.search?.toLowerCase()) ||
                      ele.lr_sr
                        ?.toLowerCase()
                        ?.includes(action.payload.search?.toLowerCase()) ||
                      ele.lr
                        ?.toLowerCase()
                        ?.includes(action.payload.search?.toLowerCase()) ||
                      ele.SoNumber?.toLowerCase()?.includes(
                        action.payload.search?.toLowerCase()
                      )))
              )
            : state.dataCp;
      } else if (action.payload.isSearch) {
        if (action.payload.search === "") {
          state.data.open_order_products =
            action.payload.sku?.length > 0
              ? state.dataCp.filter((ele) =>
                  action.payload.sku?.includes(ele.Matnr)
                )
              : state.dataCp;
        } else {
          state.data.open_order_products = state.dataCp.filter(
            (ele) =>
              ele.Matnr?.toLowerCase()?.includes(
                action.payload.search?.toLowerCase()
              ) ||
              ele.Pendingqty?.toLowerCase()?.includes(
                action.payload.search?.toLowerCase()
              ) ||
              ele.Kwmeng?.toLowerCase()?.includes(
                action.payload.search?.toLowerCase()
              ) ||
              ele.Deliveredqty?.toLowerCase()?.includes(
                action.payload.search?.toLowerCase()
              ) ||
              ele.brand
                ?.toLowerCase()
                ?.includes(action.payload.search?.toLowerCase()) ||
              ele.rim
                ?.toLowerCase()
                ?.includes(action.payload.search?.toLowerCase()) ||
              ele.size
                ?.toLowerCase()
                ?.includes(action.payload.search?.toLowerCase()) ||
              ele.refernce_po
                ?.toLowerCase()
                ?.includes(action.payload.search?.toLowerCase()) ||
              ele.li
                ?.toLowerCase()
                ?.includes(action.payload.search?.toLowerCase()) ||
              ele.lr_sr
                ?.toLowerCase()
                ?.includes(action.payload.search?.toLowerCase()) ||
              ele.lr
                ?.toLowerCase()
                ?.includes(action.payload.search?.toLowerCase()) ||
              ele.SoNumber?.toLowerCase()?.includes(
                action.payload.search?.toLowerCase()
              )
          );
        }
      } else if (action.payload.isSort) {
        console.log("came here", action.payload, state.dataCp);
        state.data.open_order_products = _.orderBy(
          state.dataCp,
          [action.payload.key],
          [action.payload.key === "SoDate" ? "desc" : action.payload.sort]
        );
      }
      return {
        ...state,
        loading: false,
      };
    }
    case LOGOUT:
      return {
        logout: action.payload,
      };

    default:
      return state;
  }
};
export const get_products_reducer = (state = {}, action) => {
  let data = Array.isArray(action?.payload)
    ? [...action?.payload]
    : typeof action?.payload === "string"
    ? action?.payload
    : { ...action?.payload };
  switch (action?.type) {
    case Products.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Products.SUCCESS: {
      return {
        ...state,
        data,
        loading: false,
        success: true,
      };
    }
    case Products.FAILED:
      return {
        ...state,
        data,
        loading: false,
        success: false,
      };
    case Products.RESET:
      return {
        loading: false,
      };

    case Products.CHANGED: {
      if (action.isQuantity && state?.data?.products?.length > 0) {
        let prods = state?.data?.products;
        prods.forEach((ele) => {
          ele.quantity = 0;
        });
        state.data.products = prods;
      }
      return {
        ...state,
        loading: false,
      };
    }
    case LOGOUT:
      return {
        logout: action.payload,
      };
    case LOGOUT_MAINTAIN:
      return {
        ...state,
        logout: action.payload,
      };
    case MAINTAINANCE:
      return {
        ...state,
        maintainace: action.payload,
      };
    default:
      return state;
  }
};
export const get_profoma_doc_reducer = ReducerFunctions(GetProfomaDoc, {});
export const update_profoma_doc_reducer = ReducerFunctions(
  UpdateProfomaDoc,
  {}
);
export const add_to_cart_reducer = ReducerFunctions(AddToCart, {});
export const create_order_reducer = ReducerFunctions(CreateOrder, {});
export const update_cart_reducer = ReducerFunctions(UpdateCart, {});
export const delete_from_cart_reducer = ReducerFunctions(
  DeleteItemFromCart,
  {}
);
export const get_cart_reducer = ReducerFunctions(GetCart, {});
export const cancel_order_reducer = ReducerFunctions(Cancel, {});
export const payments_reducer = ReducerFunctions(Payments, {});
export const download_pi_reducer = ReducerFunctions(DownloadPI, {});
export const invoice_update_reducer = ReducerFunctions(UpdateInvoice, {});
export const clear_cart_reducer = ReducerFunctions(ClearCart, {});
export const storedOrder_reducer = (
  state = {
    order_type: "FD",
    fd_origin_id: "",
    shipping_address_id: "",
  },
  action
) => {
  switch (action.type) {
    case STORED_ORDER:
      return {
        ...state,
        ...action.payload,
      };
    case LOGOUT:
      return {
        logout: action.payload,
      };

    default:
      return state;
  }
};
